<template>
  <div>
    <van-nav-bar left-text="返回" left-arrow :title="title" @click-left="onClickLeft">
      <template #right>
        <van-icon @click="onCommentAdd" name="plus" size="20"/>
      </template>
    </van-nav-bar>
    <van-field
      readonly
      v-model="flowDetail.flow.assigneeName"
      name="assigneeName"
      label="申请人"
      label-align="left"
      :rules="[{ required: true, message: '请填写申请人'}]"
    />

    <div v-for="item in flowFields.fields" :key="item.id" class="van-cell van-cell-cus">
      <van-field
        label-align="left"
        v-if="item.id === 'waterSupplyDate' && item.readOnly === true"
        readonly
        v-model="flowDetail.waterSupplyDate"
        name="waterSupplyDate"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        label-align="left"
        v-if="item.id === 'waterSupplyDate' && item.readOnly === false"
        readonly
        clickable
        name="waterSupplyDate"
        :value="flowDetail.waterSupplyDate"
        :label="item.name"
        placeholder="点击选择时间"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom"
                 v-if="item.id === 'waterSupplyDate' && item.readOnly === false">
        <van-datetime-picker
          type="date"
          :min-date="minDate"
          @confirm="onTimeConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

      <van-field
        label-align="left"
        v-if="item.id === 'builder' && item.readOnly === true"
        readonly
        v-model="flowDetail.builderToString"
        name="builder"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        label-align="left"
        v-if="item.id === 'builder' && item.readOnly === false"
        v-model="flowDetail.builderToString"
        name="builder"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />

      <van-field
        label-align="left"
        v-if="item.id === 'linkMan' && item.readOnly === true"
        readonly
        v-model="flowDetail.linkMan"
        name="linkMan"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        label-align="left"
        v-if="item.id === 'linkMan' && item.readOnly === false"
        v-model="flowDetail.linkMan"
        name="linkMan"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name  }]"
      />

      <van-field
        label-align="left"
        v-if="item.id === 'linkMobile' && item.readOnly === true"
        readonly
        v-model="flowDetail.linkMobile"
        name="linkMobile"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        label-align="left"
        v-if="item.id === 'linkMobile' && item.readOnly === false"
        v-model="flowDetail.linkMobile"
        name="linkMobile"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name  }]"
      />

      <van-field
        label-align="left"
        v-if="item.id === 'planCheckTime' && item.readOnly === true"
        readonly
        v-model="flowDetail.planCheckTime"
        name="planCheckTime"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        label-align="left"
        v-if="item.id === 'planCheckTime' && item.readOnly === false"
        readonly
        clickable
        name="planCheckTime"
        :value="currentDate"
        :label="item.name"
        placeholder="点击选择时间"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom"
                 v-if="item.id === 'planCheckTime' && item.readOnly === false">
        <van-datetime-picker
          type="date"
          :min-date="minDate"
          @confirm="onPlanCheckTimeConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

      <van-field
        label-align="left"
        v-if="item.id === 'planReCheckTime' && item.readOnly === true"
        readonly
        v-model="flowDetail.planReCheckTime"
        name="planReCheckTime"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        label-align="left"
        v-if="item.id === 'planReCheckTime' && item.readOnly === false"
        readonly
        clickable
        name="planReCheckTime"
        :value="currentDate"
        :label="item.name"
        placeholder="点击选择时间"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom"
                 v-if="item.id === 'planReCheckTime' && item.readOnly === false">
        <van-datetime-picker
          type="date"
          :min-date="minDate"
          @confirm="onPlanReCheckTimeConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

      <van-field
        label-align="left"
        v-if="item.id === 'checkLinkMan' && item.readOnly === true"
        readonly
        v-model="flowDetail.checkLinkManName"
        name="checkLinkMan"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        v-if="item.id === 'checkLinkMan' && item.readOnly === false"
        readonly
        clickable
        name="checkLinkMan"
        :value="value"
        :label="item.name"
        placeholder="点击选择现场验收负责人"
        @click="showSelectPicker = true"
      />
      <van-popup v-model="showSelectPicker" position="bottom"
                 v-if="item.id === 'checkLinkMan' && item.readOnly === false">
        <van-picker
          show-toolbar
          :columns="checkUser"
          @confirm="onCheckUserConfirm"
          @cancel="showSelectPicker = false"
        />
      </van-popup>
      <van-field
        label-align="left"
        v-if="item.id === 'checkLinkMobile' && item.readOnly === true"
        readonly
        v-model="flowDetail.checkLinkMobile"
        name="checkLinkMobile"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        label-align="left"
        v-if="item.id === 'checkLinkMobile' && item.readOnly === false"
        v-model="flowDetail.checkLinkMobile"
        name="checkLinkMobile"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name  }]"
      />

      <van-field name="applyFile" :label="item.name" v-if="item.id === 'applyFile' && item.readOnly === true">
        <template #input>
          <van-uploader v-model="applyFileList" :deletable="false" :show-upload="false">
            <template #preview-cover="{ url,oriName }">
              <div class="preview-cover van-ellipsis"><a :href="url">{{ oriName }}</a></div>
            </template>
          </van-uploader>
        </template>
      </van-field>
      <van-field name="applyFile" :label="item.name"
                 v-if="item.id === 'applyFile' && item.readOnly === false"
                 rules="[{ required: true, message: '请先上传文件' }]">
        <template #input>
          <van-uploader :before-read="beforeApplyFileRead" :after-read="afterApplyFileRead"
                        :max-size="5000 * 1024" max-count="6" v-model="applyFileList" multiple
                        :before-delete="beforeApplyFileDelete"
                        accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
            <template #preview-cover="{ url,oriName }">
              <div class="preview-cover van-ellipsis"><a :href="url">{{ oriName }}</a></div>
            </template>
          </van-uploader>
        </template>
      </van-field>

      <van-field name="jlAuditFile" :label="item.name" v-if="item.id === 'jlAuditFile' && item.readOnly === true">
        <template #input>
          <van-uploader v-model="jlAuditFileList" :deletable="false" :show-upload="false">
            <template #preview-cover="{ url,oriName }">
              <div class="preview-cover van-ellipsis"><a :href="url">{{ oriName }}</a></div>
            </template>
          </van-uploader>
        </template>
      </van-field>
      <van-field name="jlAuditFile" :label="item.name"
                 v-if="item.id === 'jlAuditFile' && item.readOnly === false"
                 :rules="[{ required: true, message: '请先上传文件' }]">
        <template #input>
          <van-uploader :before-read="beforeRead" :after-read="afterRead"
                        :max-size="5000 * 1024" max-count="6" v-model="jlAuditFileList" multiple
                        :before-delete="beforeDelete"
                        accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
            <template #preview-cover="{ url,oriName }">
              <div class="preview-cover van-ellipsis"><a :href="url">{{ oriName }}</a></div>
            </template>
          </van-uploader>
        </template>
      </van-field>

      <van-field name="receiptFile" :label="item.name" v-if="item.id === 'receiptFile' && item.readOnly === true">
        <template #input>
          <van-uploader v-model="receiptFileList" :deletable="false" :show-upload="false">
            <template #preview-cover="{ url,oriName }">
              <div class="preview-cover van-ellipsis"><a :href="url">{{ oriName }}</a></div>
            </template>
          </van-uploader>
        </template>
      </van-field>
      <van-field name="receiptFile" :label="item.name"
                 v-if="item.id === 'receiptFile' && item.readOnly === false"
                 :rules="[{ required: true, message: '请先上传文件' }]">
        <template #input>
          <van-uploader :before-read="beforeReadReceiptFile" :after-read="afterReadReceiptFile"
                        :max-size="5000 * 1024" max-count="6" v-model="receiptFileList" multiple
                        :before-delete="beforeDeleteReceiptFile"
                        accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
            <template #preview-cover="{ url,oriName }">
              <div class="preview-cover van-ellipsis"><a :href="url">{{ oriName }}</a></div>
            </template>
          </van-uploader>
        </template>
      </van-field>

      <van-field
        label-align="left"
        v-if="item.id === 'realCheckTime' && item.readOnly === true"
        readonly
        v-model="flowDetail.realCheckTime"
        name="realCheckTime"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        label-align="left"
        v-if="item.id === 'realCheckTime' && item.readOnly === false"
        readonly
        clickable
        name="realCheckTime"
        :value="currentDate"
        :label="item.name"
        placeholder="点击选择时间"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom"
                 v-if="item.id === 'realCheckTime' && item.readOnly === false">
        <van-datetime-picker
          type="date"
          :min-date="minDate"
          :formatter="formatter"
          @confirm="onRealCheckTimeConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

      <van-field
        label-align="left"
        v-if="item.id === 'realCheckEndTime' && item.readOnly === true"
        readonly
        v-model="flowDetail.realCheckEndTime"
        name="realCheckEndTime"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        label-align="left"
        v-if="item.id === 'realCheckEndTime' && item.readOnly === false"
        readonly
        clickable
        name="realCheckEndTime"
        :value="endCurrentDate"
        :label="item.name"
        placeholder="点击选择时间"
        @click="showEndPicker = true"
      />
      <van-popup v-model="showEndPicker" position="bottom"
                 v-if="item.id === 'realCheckEndTime' && item.readOnly === false">
        <van-datetime-picker
          type="date"
          :min-date="minDate"
          :formatter="formatter"
          @confirm="onRealCheckEndTimeConfirm"
          @cancel="showEndPicker = false"
        />
      </van-popup>

      <van-field
        label-align="left"
        v-if="item.id === 'realReCheckTime' && item.readOnly === true"
        readonly
        v-model="flowDetail.realReCheckTime"
        name="realReCheckTime"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        label-align="left"
        v-if="item.id === 'realReCheckTime' && item.readOnly === false"
        readonly
        clickable
        name="realReCheckTime"
        :value="currentDate"
        :label="item.name"
        placeholder="点击选择时间"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom"
                 v-if="item.id === 'realReCheckTime' && item.readOnly === false">
        <van-datetime-picker
          type="date"
          :min-date="minDate"
          @confirm="onRealReCheckTimeConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

      <van-field
        label-align="left"
        v-if="item.id === 'realReCheckEndTime' && item.readOnly === true"
        readonly
        v-model="flowDetail.realReCheckEndTime"
        name="realReCheckEndTime"
        :label="item.name"
        :rules="[{ required: true, message: '请填写' + item.name }]"
      />
      <van-field
        label-align="left"
        v-if="item.id === 'realReCheckEndTime' && item.readOnly === false"
        readonly
        clickable
        name="realReCheckEndTime"
        :value="endCurrentDate"
        :label="item.name"
        placeholder="点击选择时间"
        @click="showEndPicker = true"
      />
      <van-popup v-model="showEndPicker" position="bottom"
                 v-if="item.id === 'realReCheckEndTime' && item.readOnly === false">
        <van-datetime-picker
          type="date"
          :min-date="minDate"
          @confirm="onRealReCheckEndTimeConfirm"
          @cancel="showEndPicker = false"
        />
      </van-popup>

      <van-field
        v-if="item.id === 'checkResult' && item.readOnly === false"
        readonly
        clickable
        name="checkResult"
        :value="value"
        :label="item.name"
        placeholder="点击选择验收结果"
        @click="showSelectPicker = true"
      />
      <van-popup v-model="showSelectPicker" position="bottom"
                 v-if="item.id === 'checkResult' && item.readOnly === false">
        <van-picker
          show-toolbar
          :columns="checkResultColumns"
          @confirm="onDicConfirm"
          @cancel="showSelectPicker = false"
        />
      </van-popup>

      <van-field name="checkFile" :label="item.name" v-if="item.id === 'checkFile' && item.readOnly === true">
        <template #input>
          <van-uploader v-model="checkFileList" :deletable="false" :show-upload="false">
            <template #preview-cover="{ url,oriName }">
              <div class="preview-cover van-ellipsis"><a :href="url">{{ oriName }}</a></div>
            </template>
          </van-uploader>
        </template>
      </van-field>
      <van-field name="checkFile" :label="item.name"
                 v-if="item.id === 'checkFile' && item.readOnly === false"
                 :rules="[{ required: true, message: '请先上传文件' }]">
        <template #input>
          <van-uploader :before-read="beforeReadCheckFile" :after-read="afterReadCheckFile"
                        :max-size="5000 * 1024" max-count="6" v-model="checkFileList" multiple
                        :before-delete="beforeDeleteCheckFile"
                        accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
            <template #preview-cover="{ url,oriName }">
              <div class="preview-cover van-ellipsis"><a :href="url">{{ oriName }}</a></div>
            </template>
          </van-uploader>
        </template>
      </van-field>

      <van-field name="printFile" :label="item.name"
                 v-if="item.id === 'printFile' && item.readOnly === false"
                 :rules="[{ required: true, message: '请先上传文件' }]">
        <template #input>
          <van-uploader :before-read="beforeReadPrintFile" :after-read="afterReadPrintFile"
                        :max-size="5000 * 1024" max-count="6" v-model="printFileList" multiple
                        :before-delete="beforeDeletePrintFile"
                        accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
            <template #preview-cover="{ url,oriName }">
              <div class="preview-cover van-ellipsis"><a :href="url">{{ oriName }}</a></div>
            </template>
          </van-uploader>
        </template>
      </van-field>

      <van-field name="downloadyanshoushu" v-if="item.id === 'downloadyanshoushu'">
        <template #input>
          <van-button plain hairline type="info" @click="openUrl(item.name)">{{ item.name }}</van-button>
        </template>
      </van-field>
    </div>
    <van-field
      label-align="left"
      v-model="comment"
      rows="2"
      autosize
      label="批复意见"
      type="textarea"
      maxlength="50"
      placeholder="请输入批复意见"
      show-word-limit
    />

    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="handleAgree">提交</van-button>
      <van-button v-if="this.disagreeBtnVisible" style="margin-top: 10px;" round block type="danger"
                  native-type="submit" @click="handleDisagree">驳回
      </van-button>
    </div>
  </div>
</template>

<script>
import {Toast} from "vant";
import {getToken} from "../../utils/auth";
import {fetch} from "../../utils/http";
import {isLogin, isWechat} from "../../utils/util";

export default {
  name: "FlowApprove",
  data() {
    return {
      flowFields: {},
      flowDetail: {},
      taskId: '',
      processInstanceId: '',
      businessId: '',
      processDefinitionKey: '',
      disagreeBtnVisible: false,
      showPopover: false,
      showPicker: false,
      showEndPicker: false,
      showSelectPicker: false,
      actions: [
        {text: '待办处理', icon: 'records'},
        {text: '批注信息', icon: 'edit'},
        {text: '流程信息', icon: 'clock-o'},
      ],
      offset: [15, 0],
      jlAuditFileList: [],
      jlAuditFileIds: [],
      applyFileList: [],
      applyFileIds: [],
      receiptFileList: [],
      receiptFileIds: [],
      checkFileList: [],
      checkFileIds: [],
      printFileList: [],
      printFileIds: [],
      comment: '',
      currentDate: '',
      endCurrentDate: '',
      minDate: new Date(2021, 0, 1),
      checkResultColumns: [],
      checkUser: [],
      checkCode: 'BluePrint_checkResult',
      title: '',
    };
  },
  created() {

  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.businessId = this.$route.query.businessId;
    this.processDefinitionKey = this.$route.query.processDefinitionKey;
    this.taskId = this.$route.query.taskId;
    this.processInstanceId = this.$route.query.processInstanceId;
    this.getUserTaskFormData();
  },
  methods: {
    // 选项格式化函数
    formatter (type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      } else if (type === 'hour') {
        return `${value}时`
      } else if (type === 'minute') {
        return `${value}分`
      } else if (type === 'second') {
        return `${value}秒`
      }
      return value
    },
    onDicConfirm(value) {
      this.value = value.text;
      this.flowDetail.checkResult = value.dictKey;
      this.showSelectPicker = false;
    },
    onCheckUserConfirm(value) {
      this.value = value.text;
      this.flowDetail.checkLinkMan = value.userId;
      this.showSelectPicker = false;
      let userUrl = "/pipe-line-api/blade-user/getUserDetail";
      this.$fetch(userUrl, {
        id: value.userId,
      }).then(
        res => {
          const data = res.data;
          this.flowDetail.checkLinkMobile = data.phone;
          console.log("返回的现场验收人详情：" + JSON.stringify(data));
        },
        error => {
        }
      );
    },
    initDicData: function () {
      let url = "/pipe-line-api/blade-system/dict-biz/dictionary4Pc";
      this.$fetch(url, {
        code: this.checkCode,
      }).then(
        res => {
          const data = res.data;
          data.forEach(function (column) {
            column.text = column.dictValue;
          });
          this.checkResultColumns = data;
          console.log("返回的字典数据：" + JSON.stringify(this.checkResultColumns));
        },
        error => {
        }
      );

      let userUrl = "/pipe-line-api/blade-user/userListByRole";
      this.$fetch(userUrl, {
        roleAlias: 'gxs_ysfzr',
      }).then(
        res => {
          const data = res.data;
          data.forEach(function (column) {
            column.text = column.userExt;
          });
          this.checkUser = data;
          console.log("返回的现场验收人：" + JSON.stringify(this.checkUser));
        },
        error => {
        }
      );
    },
    getUserTaskFormData: function () {
      let url = "/pipe-line-api/blade-flow/process/getUserTaskFormData";
      this.$fetch(url, {
        taskId: this.taskId,
      }).then(
        res => {
          const data = res.data;
          this.flowFields = data;
          this.title = data.name;
          if (this.title == '图卡合格确认' || this.title == '现场复验') {
            this.checkCode = 'BluePrint_tk_checkResult';
          }
          //循环表单属性判断是否需要展示驳回按钮
          for (let formProperty of this.flowFields.fields) {
            if (formProperty.id == 'disagreeBtnVisible') {
              this.disagreeBtnVisible = true;
            }
          }
          console.log("返回的表单数据：" + JSON.stringify(this.flowFields));
          this.getPipeFlowDetail();
          this.initDicData();
        },
        error => {
        }
      );
    },
    getPipeFlowDetail: function () {
      let url = "";
      if (this.processDefinitionKey == 'BluePrintAccept') {
        url = "/pipe-line-api/blade-desk/process/bluePrintAccept/detail";
      } else if (this.processDefinitionKey == 'SurveyAccept') {
        url = "/pipe-line-api/blade-desk/process/surveyAccept/detail";
      } else if (this.processDefinitionKey == 'SelfBuilt') {
        url = "/pipe-line-api/blade-desk/process/selfBuilt/detail";
      }
      this.$fetch(url, {
        businessId: this.businessId,
      }).then(
        res => {
          const data = res.data;
          this.flowDetail = data;
          this.applyFileList = this.flowDetail.allFiles.applyFile;
          let applyFileIds = [];
          this.applyFileList.forEach(function (column) {
            column.url = column.viewUrl.replace('http://10.0.100.82','http://m.jlwater.com:8007');
            applyFileIds.push(column.id);
          });
          this.applyFileIds = applyFileIds;

          this.jlAuditFileList = this.flowDetail.allFiles.jlAuditFile;
          let ids = [];
          this.jlAuditFileList.forEach(function (column) {
            column.url = column.viewUrl.replace('http://10.0.100.82','http://m.jlwater.com:8007');
            ids.push(column.id);
          });
          this.jlAuditFileIds = ids;

          this.receiptFileList = this.flowDetail.allFiles.receiptFile;
          let receiptFileIds = [];
          this.receiptFileList.forEach(function (column) {
            column.url = column.viewUrl.replace('http://10.0.100.82','http://m.jlwater.com:8007');
            receiptFileIds.push(column.id);
          });
          this.receiptFileIds = receiptFileIds;

          this.checkFileList = this.flowDetail.allFiles.checkFile;
          let checkFileIds = [];
          this.checkFileList.forEach(function (column) {
            column.url = column.viewUrl.replace('http://10.0.100.82','http://m.jlwater.com:8007');
            checkFileIds.push(column.id);
          });
          this.checkFileIds = checkFileIds;

          this.printFileList = this.flowDetail.allFiles.printFile;
          let printFileIds = [];
          this.printFileList.forEach(function (column) {
            column.url = column.viewUrl.replace('http://10.0.100.82','http://m.jlwater.com:8007');
            printFileIds.push(column.id);
          });
          this.printFileIds = printFileIds;
          console.log("返回的数据：" + JSON.stringify(this.printFileIds));
        },
        error => {
        }
      );
    },
    onClickLeft: function () {
      this.backToDetail();
    },
    backToDetail: function () {
      this.$router.push({
        path: "/pipeflow/FlowDetail",
        query: {
          taskId: this.taskId,
          processInstanceId: this.processInstanceId,
          businessId: this.businessId,
          processDefinitionKey: this.processDefinitionKey
        }
      });
    },
    // 返回布尔值
    beforeApplyFileRead(file) {
      return true;
    },
    afterApplyFileRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizType', this.processDefinitionKey);
      formData.append('bizId', this.businessId);
      formData.append('bizColumn', 'applyFile');
      this.$filePost("/pipe-line-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.applyFileIds.push(data.id);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeApplyFileDelete(file, detail) {
      let index = JSON.stringify(detail.index);
      let delId = this.applyFileIds[index];
      let url = "/pipe-line-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.applyFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.applyFileIds);
        },
        error => {
        }
      );
      return true;
    },
    // 返回布尔值
    beforeRead(file) {
      return true;
    },
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizType', this.processDefinitionKey);
      formData.append('bizId', this.businessId);
      formData.append('bizColumn', 'jlAuditFile');
      this.$filePost("/pipe-line-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.jlAuditFileIds.push(data.id);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeDelete(file, detail) {
      let index = JSON.stringify(detail.index);
      let delId = this.jlAuditFileIds[index];
      let url = "/pipe-line-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.jlAuditFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.jlAuditFileIds);
        },
        error => {
        }
      );
      return true;
    },
    // 返回布尔值
    beforeReadReceiptFile(file) {
      return true;
    },
    afterReadReceiptFile(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizType', this.processDefinitionKey);
      formData.append('bizId', this.businessId);
      formData.append('bizColumn', 'receiptFile');
      this.$filePost("/pipe-line-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.receiptFileIds.push(data.id);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeDeleteReceiptFile(file, detail) {
      debugger;
      let index = JSON.stringify(detail.index);
      let delId = this.receiptFileIds[index];
      let url = "/pipe-line-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.receiptFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.receiptFileIds);
        },
        error => {
        }
      );
      return true;
    },
    onTimeConfirm(time) {
      this.currentDate = this.$moment(time).format('YYYY-MM-DD');
      this.flowDetail.waterSupplyDate = this.currentDate;
      this.showPicker = false;
    },
    onPlanCheckTimeConfirm(time) {
      this.currentDate = this.$moment(time).format('YYYY-MM-DD');
      this.flowDetail.planCheckTime = this.currentDate;
      this.showPicker = false;
    },
    onPlanReCheckTimeConfirm(time) {
      this.currentDate = this.$moment(time).format('YYYY-MM-DD');
      this.flowDetail.planReCheckTime = this.currentDate;
      this.showPicker = false;
    },
    onRealCheckTimeConfirm(time) {
      this.currentDate = this.$moment(time).format('YYYY-MM-DD');
      this.flowDetail.realCheckTime = this.currentDate;
      this.showPicker = false;
    },
    onRealCheckEndTimeConfirm(time) {
      this.endCurrentDate = this.$moment(time).format('YYYY-MM-DD');
      this.flowDetail.realCheckEndTime = this.endCurrentDate;
      this.showEndPicker = false;
    },
    onRealReCheckTimeConfirm(time) {
      this.currentDate = this.$moment(time).format('YYYY-MM-DD');
      this.flowDetail.realReCheckTime = this.currentDate;
      this.showPicker = false;
    },
    onRealReCheckEndTimeConfirm(time) {
      this.endCurrentDate = this.$moment(time).format('YYYY-MM-DD');
      this.flowDetail.realReCheckEndTime = this.endCurrentDate;
      this.showEndPicker = false;
    },
    backToFlowList: function () {
      this.$router.push({
        path: "/pipeflow/FlowList",
        query: {}
      });
    },
    // 返回布尔值
    beforeReadCheckFile(file) {
      return true;
    },
    afterReadCheckFile(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizType', this.processDefinitionKey);
      formData.append('bizId', this.businessId);
      formData.append('bizColumn', 'checkFile');
      this.$filePost("/pipe-line-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.checkFileIds.push(data.id);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeDeleteCheckFile(file, detail) {
      debugger;
      let index = JSON.stringify(detail.index);
      let delId = this.checkFileIds[index];
      let url = "/pipe-line-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.checkFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.checkFileIds);
        },
        error => {
        }
      );
      return true;
    },
    // 返回布尔值
    beforeReadPrintFile(file) {
      return true;
    },
    afterReadPrintFile(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizType', this.processDefinitionKey);
      formData.append('bizId', this.businessId);
      formData.append('bizColumn', 'printFile');
      this.$filePost("/pipe-line-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.printFileIds.push(data.id);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeDeletePrintFile(file, detail) {
      debugger;
      let index = JSON.stringify(detail.index);
      let delId = this.printFileIds[index];
      let url = "/pipe-line-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.printFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.printFileIds);
        },
        error => {
        }
      );
      return true;
    },
    handleDisagree() {
      if (this.comment == '') {
        Toast('请先填写批复意见');
        return false;
      }
      let url = "";
      if (this.processDefinitionKey == 'BluePrintAccept') {
        url = "/pipe-line-api/blade-desk/process/bluePrintAccept/complete-task";
      } else if (this.processDefinitionKey == 'SurveyAccept') {
        url = "/pipe-line-api/blade-desk/process/surveyAccept/complete-task";
      } else if (this.processDefinitionKey == 'SelfBuilt') {
        url = "/pipe-line-api/blade-desk/process/selfBuilt/complete-task";
      }

      const params = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        comment: this.comment,
        pass: false,
      }
      this.flowDetail.flow = params;
      this.$bodyPost(url, this.flowDetail).then(
        res => {
          const data = res.data;
          Toast('操作成功');
          this.backToFlowList();
        },
        error => {
        }
      );
    },
    handleAgree: function () {
      let url = "";
      if (this.processDefinitionKey == 'BluePrintAccept') {
        url = "/pipe-line-api/blade-desk/process/bluePrintAccept/complete-task";
      } else if (this.processDefinitionKey == 'SurveyAccept') {
        url = "/pipe-line-api/blade-desk/process/surveyAccept/complete-task";
      } else if (this.processDefinitionKey == 'SelfBuilt') {
        url = "/pipe-line-api/blade-desk/process/selfBuilt/complete-task";
      }

      const params = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        comment: this.comment,
        flag: 'ok',
      }
      this.flowDetail.flow = params;
      this.$bodyPost(url, this.flowDetail).then(
        res => {
          const data = res.data;
          Toast('操作成功');
          this.backToFlowList();
        },
        error => {
        }
      );
    },
    openUrl(name) {
      let url = "/pipe-line-api/blade-desk/process/bluePrintAccept/down-pdf";
      const params = {
        id: this.businessId,
      }
      this.$fileFetch(url, params).then(
        res => {
          const data = res;
          let blob = new Blob([data], {
            //type类型后端返回来的数据中会有，根据自己实际进行修改
            // 表格下载为 application/xlsx，压缩包为 application/zip等，
            type: "application/pdf"
          });
          let filename = name;
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            window.navigator.msSaveBlob(blob, filename);
          } else {
            var blobURL = window.URL.createObjectURL(blob);
            // 创建隐藏<a>标签进行下载
            var tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", filename);
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
          }
        },
        error => {
        }
      );
    },
    onCommentAdd(){
      this.$router.push({
        path: "/pipeflow/FlowComment",
        query: {
          taskId: this.taskId,
          taskName: this.title,
          processInstanceId: this.processInstanceId,
          businessId: this.businessId,
          processDefinitionKey: this.processDefinitionKey
        }
      });
    }
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

.preview-cover {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
}

.van-cell-cus {
  padding: 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/FlowApprove.vue